import React, { useEffect, useRef, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import { GET_ALL_USERS_ERROR, getAllUsersForChat, getChatList } from '../../Redux/Actions/Actions';
import Loader from '../Reusable_Components/loader';
import Footer from "../Login/Footer";
import { IoAdd, IoArrowBack, IoCheckmarkDoneCircle, IoClose } from "react-icons/io5";
import axios from 'axios';
import { VscSend } from "react-icons/vsc";

import { base_url, wss_url } from '../../utilities';
import { GoSearch } from 'react-icons/go';
import { convertUTCToLocal } from './ReusableFunctions';
import { RiChatNewFill } from 'react-icons/ri';
import { CiCircleRemove } from "react-icons/ci";
import { FaCircle, FaEye, FaRegArrowAltCircleLeft, FaRegArrowAltCircleRight, FaRegCheckCircle } from "react-icons/fa";
import { MdGroupAdd } from "react-icons/md";
import { Modal } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import ImageViewer from './ImageViewer';
import AlertPopup from '../Reusable_Components/Alert'
import { GrDocumentPdf } from 'react-icons/gr';
import { HiUserGroup } from "react-icons/hi";

export default function Chat({ setViewChat, ws, webSocketConnection, setUnreadMessageCount, unreadChatArray, setUnreadChatArray }) {

    // const socket = io.connect(base_url)
    const [chatGroupList, setChatGroupList] = useState([])
    const contractApiLoader = useSelector(state => state.contractApiLoader)
    const unreadChatList = useSelector(state => state.unreadChatList)
    const username = localStorage.getItem('username')
    const name = localStorage.getItem('name')
    const group = localStorage.getItem('group')
    const user_token = localStorage.getItem('access_token');
    const loading = useSelector(state => state.loading)
    const usersList = useSelector(state => state.userListForChat)
    const dispatch = useDispatch();
    const [selectedChatUser, setSelectedChatUser] = useState(null)
    const error = useSelector(state => state.error);
    const [isLoading, setIsLoading] = useState(false)
    const [usersArray, setUsersArray] = useState([])
    const [chatType, setChatType] = useState('chat')
    const [specificChatType, setSpecificChatType] = useState('chat')
    const [textInput, setTextInput] = useState('')
    const [selectedChat, setSelectedChat] = useState(null);
    const [chatsArray, setChatsArray] = useState([])
    const [allUsersWithChats, setAllUsersWithChats] = useState([])
    const [allUsersWithChatsForGroup, setAllUsersWithChatsForGroup] = useState([])
    const [membersIdInGroup, setMembersIdInGroup] = useState([])
    const [isPaused, setPause] = useState(false);
    const [chats, setChats] = useState([])
    const [userId, setUserId] = useState(localStorage.getItem('user_id'))
    // const ws = useRef(null);
    const [isFirstClose, setIsFirstClosed] = useState(true)

    const [minimizedChat, setMinimizedChat] = useState(true)
    const [mobileChatWindow, setMobileChatWindow] = useState(false)

    const [searchText, setSearchText] = useState('')

    const [groupChats, setGroupChats] = useState([])
    const [groupChatsArray, setGroupChatsArray] = useState([])
    const [recentChatsArray, setRecentChatsArray] = useState([])
    const [minimizeRecentChats, setMinimizeRecentChats] = useState(true)
    const [minimizeAllUsers, setMinimizeAllUsers] = useState(true)

    const [chatGroupId, setChatGroupId] = useState('')
    const [selectedChatGroup, setSelectedChatGroup] = useState(null)

    // for group chat creation
    const [groupChatName, setGroupChatName] = useState('')
    const [groupChatDescription, setGroupChatDescription] = useState('')
    const [groupChatMembers, setGroupChatMembers] = useState([])
    const [groupChatMembersArray, setGroupChatMembersArray] = useState([])
    const [isGroupChatButtonClicked, setIsGroupChatButtonClicked] = useState(false)
    const [isGroupChatNextClicked, setIsGroupChatNextClicked] = useState(false)
    const [addGroupMemberModalClicked, setAddGroupMemberModalClicked] = useState(false)
    const [showGroupMembers, setShowGroupMembers] = useState(false)
    const [isChatUserOnline, setIsChatUserOnline] = useState(false)
    const [chatMemberId, setChatMemberId] = useState(null)
    const [isNewGroupChat, setIsNewGroupChat] = useState(false)

    // for read receipt
    const messagesEndRef = useRef(null);
    const messagesRef = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(true);
    const [unreadCountArray, setUnreadCountArray] = useState([])

    const [documentsUpload, setDocumentsUpload] = useState(false)
    const [selectedFiles, setSelectedFiles] = useState([])
    const [selectedFilesData, setSelectedFilesData] = useState([])

    const [uploadedS3Keys, setUploadedS3Keys] = useState([])
    const [viewImage, setViewImage] = useState(null)

    const [errorMsg, setErrorMsg] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)
    const [limit, setLimit] = useState(20)
    const [hasMore, setHasMore] = useState(true)
    const [newMessage, setNewMessage] = useState(false)
    const [isLastSentMessageSeen, setIsLastSentMessageSeen] = useState(false)

    const [allChats, setAllChats] = useState({})
    const [groupMembers, setGroupMembers] = useState({})
    // for online/offline status
    // const [webSocketConnection, setWebSocketConnection] = useState(false)
    const [showCamera, setShowCamera] = useState(false)
    const [cameraView, setCameraView] = useState("environment")
    const [capturedImage, setCapturedImage] = useState(null)
    const webcamRef = useRef(null);

    const [onlineUsers, setOnlineUsers] = useState([])

    const [showDeleteMemberConfirm, setShowDeleteMemberConfirm] = useState(false);
    const [memberToDelete, setMemberToDelete] = useState(null);

    const [showLeaveGroupConfirm, setShowLeaveGroupConfirm] = useState(false);
    const [memberToLeave, setMemberToLeave] = useState(null);

    useEffect(() => {
        if (unreadChatList && groupChats) {
            let groupChatsArray = groupChats
            groupChatsArray?.forEach(group => {
                const chatGroup = unreadChatList.find(chat => chat.chat_group_id === group.chat_group_id)
                if (chatGroup && chatGroup.unread_count > 0) {
                    group.new_message_sent = true
                    group.unread_count = chatGroup.unread_count
                    group.last_message = chatGroup.last_message
                }
            })
            setGroupChats(groupChatsArray)
            setRecentChatsArray(groupChatsArray)
        }
        let totalUnreadCount = 0
        unreadChatList?.forEach(chat => {
            if (chat.unread_count > 0) {
                totalUnreadCount = totalUnreadCount + 1
            }
        })
        setUnreadMessageCount(totalUnreadCount)
    }, [unreadChatList])

    useEffect(() => {
        const handleResize = () => {
            setMinimizedChat(window.innerWidth < 768);
        };

        handleResize(); // Check initial screen size
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [window.innerWidth]);

    useEffect(() => {
        if (usersList) {
            setUsersArray(usersList)
            const usersWithchats = []

            usersList?.forEach(user => {
                usersWithchats.push({
                    name: user.name,
                    username: user.username,
                    user_id: user.user_id,
                    message: []
                })
            })
            setChatsArray(usersWithchats)
            setAllUsersWithChats(usersWithchats)
            // exclude all members present in groupchatmemberArray
            const groupChatMemberAdding = groupChatMembersArray.map(member => member.user_id)
            const usersWithchatsForGroup = usersList?.filter(user => !groupChatMemberAdding.includes(user.user_id))
            setAllUsersWithChatsForGroup(usersWithchatsForGroup)
        }
    }, [usersList])

    useEffect(() => {
        fetchAllUsers()
        fetchUserGroups()
        fetchOnlineStatus()
        dispatch(getChatList(userId))
    }, [searchText])

    // useEffect(() => {
    //     // connectToSocket()
    //     const secretKey =
    //         "PortOSKey";
    //     const encryptedToken = encryptToken(user_token, secretKey);
    //     const socketUrl = `${wss_url}?token=${encodeURIComponent(encryptedToken)}`;
    //     ws.current = new WebSocket(socketUrl);
    //     ws.current.onopen = () => {
    //         // fetchMessagesUnread()
    //         setWebSocketConnection(true)
    //         console.log("ws opened");
    //     };
    //     ws.current.onclose = () => {
    //         setWebSocketConnection(false)
    //         console.log("ws closed");
    //         // reconnect to socket
    //         // ws.current = null;
    //         // setTimeout(() => {
    //         //     connectToSocket();
    //         // }, 1000);
    //     };

    //     const wsCurrent = ws.current;

    //     return () => {
    //         wsCurrent.close();
    //     };
    // }, []);

    // const connectToSocket = () => {
    //     // const secretKey =
    //     //     "PortOSKey";
    //     // const encryptedToken = encryptToken(user_token, secretKey);
    //     const socketUrl = `${wss_url}?token=${encodeURIComponent(user_token)}`;
    //     ws.current = new WebSocket(socketUrl);
    //     ws.current.onopen = () => {
    //         // fetchMessagesUnread()
    //         console.log("ws opened");
    //     };
    //     ws.current.onclose = () => {
    //         console.log("ws closed");
    //         // reconnect to socket
    //         ws.current = null;
    //         setTimeout(() => {
    //             connectToSocket();
    //         }, 1000);

    //     };
    // }

    const disconnectToSocket = () => {
        ws.current.close();
    }

    useEffect(() => {
        if (!ws.current) return;
        ws.current.onmessage = async (e) => {
            if (isPaused) return;
            const message = JSON.parse(e.data);
            if (message?.message_type === 'online_status') {
                if (message?.status === 'online') {
                    // setIsChatUserOnline(true)
                    setOnlineUsers(prev => [...prev, message?.user_id])
                    if (groupMembers && groupMembers[selectedChatUser?.chat_group_id]) {
                        setIsChatUserOnline(message?.user_id === groupMembers[selectedChatUser?.chat_group_id])
                    } else {
                        if (chatMemberId === message?.user_id) {
                            setIsChatUserOnline(true)
                        }
                    }
                } else {
                    // delete user from online users
                    let offlineUsersFilter = onlineUsers.filter(user => user !== message?.user_id)
                    setOnlineUsers(offlineUsersFilter)
                    // setOnlineUsers(prev => prev.filter(user => user !== message?.user_id))
                    if (groupMembers && groupMembers[selectedChatUser?.chat_group_id]) {
                        setIsChatUserOnline(offlineUsersFilter.includes(groupMembers[selectedChatUser?.chat_group_id]))
                    } else {
                        if (chatMemberId === message?.user_id) {
                            setIsChatUserOnline(false)
                        }
                    }
                }
            }
            else if (message?.message_type === 'acknowledgement') {
                // update the message with chat_message_id
                let chatMessage = selectedChatUser?.message.find(chat => chat.message_dummy_id === message.message_dummy_id)
                if (chatMessage) {
                    chatMessage['chat_message_id'] = message?.chat_message_id
                }
                const newChatArray = selectedChatUser?.message.map(chat => chat.message_dummy_id === message.message_dummy_id ? chatMessage : chat)
                setSelectedChatUser(prev => ({ ...prev, message: newChatArray }))
            }
            else if (message?.message_type === 'unread_messages_array') {
                const unreadMessagesArray = message?.unread_messages
                let groupChatsArray = groupChats
                groupChatsArray?.forEach(group => {
                    const chatGroup = unreadMessagesArray.find(chat => chat.chat_group_id === group.chat_group_id)
                    if (chatGroup) {
                        group.new_message_sent = true
                        group.unread_count = chatGroup.unread_count
                    }
                })
                setGroupChats(groupChatsArray)
                setRecentChatsArray(groupChatsArray)
                setUnreadCountArray(unreadMessagesArray)
            }
            else {
                let documents = [];
                const s3_keys = getS3Keys(message?.sent_message);
                if (s3_keys.length > 0) {
                    documents = await getDocuments(s3_keys);
                }
                if (selectedChatUser?.chat_group_id === message.chat_group_id) {
                    setSelectedChatUser(prev => {
                        return {
                            ...prev,
                            message: [...prev.message, {
                                type: 'received',
                                message: parseMessage(message.sent_message),
                                chat_group_id: message.chat_group_id,
                                chat_message_id: message.chat_message_id,
                                chat_at: message.chat_at,
                                created_by: message.from,
                                s3_keys: documents,
                                time: new Date().toISOString()
                            }]
                        }
                    })
                    setAllChats({
                        ...allChats, [message.chat_group_id]: {
                            chat_group_id: message.chat_group_id,
                            name: message.to,
                            username: message.to,
                            user_id: message.chat_group_id,
                            is_group_chat: message.new_group,
                            message: [...(allChats[message.chat_group_id]?.message || []), {
                                type: 'received',
                                message: parseMessage(message.sent_message),
                                chat_group_id: message.chat_group_id,
                                chat_message_id: message.chat_message_id,
                                chat_at: message.chat_at,
                                created_by: message.from,
                                s3_keys: documents,
                                time: new Date().toISOString()
                            }]
                        }
                    });
                    setNewMessage(!newMessage)
                } else {
                    allChats[message.chat_group_id] ? setAllChats({
                        ...allChats, [message.chat_group_id]: {
                            chat_group_id: message.chat_group_id,
                            name: message.to,
                            username: message.to,
                            user_id: message.chat_group_id,
                            is_group_chat: message.new_group,
                            message: [...(allChats[message.chat_group_id]?.message || []), {
                                type: 'received',
                                message: parseMessage(message.sent_message),
                                chat_group_id: message.chat_group_id,
                                chat_message_id: message.chat_message_id,
                                chat_at: message.chat_at,
                                created_by: message.from,
                                s3_keys: documents,
                                time: new Date().toISOString()
                            }]
                        }
                    }) :
                        getChatForGroup({ chat_group_id: message.chat_group_id, chat_group_name: message.to, is_group_chat: message.new_group }, false)
                    // setAllChats({
                    //     ...allChats, [message.chat_group_id]: {
                    //         chat_group_id: message.chat_group_id,
                    //         name: message.to,
                    //         username: message.to,
                    //         user_id: message.chat_group_id,
                    //         is_group_chat: message.new_group,
                    //         message: [...(allChats[message.chat_group_id]?.message || []), {
                    //             type: 'received',
                    //             message: parseMessage(message.sent_message),
                    //             chat_group_id: message.chat_group_id,
                    //             chat_message_id: message.chat_message_id,
                    //             chat_at: message.chat_at,
                    //             created_by: message.from,
                    //             s3_keys: documents,
                    //             time: new Date().toISOString()
                    //         }]
                    //     }
                    // });
                    const audio = new Audio('/notification.wav'); // Adjust path if needed
                    audio.play();
                }
                if (message.new_group) {
                    const newGroupChat = {
                        name: message.to,
                        username: message.to,
                        chat_group_name: message.to,
                        user_id: message.chat_group_id,
                        description: "One On One Chat",
                        chat_group_id: message.chat_group_id,
                        "active_ind": 1,
                        "archived_ind": 0,
                        "deleted_ind": 0,
                        "creator_name": name,
                        new_message_sent: true,
                        unread_count: 1
                    }
                    const newChatGroupArray = {
                        name: message.to,
                        username: message.to,
                        chat_group_id: message.chat_group_id,
                        user_id: message.chat_group_id,
                        message: [
                            {
                                type: 'received',
                                message: message.message_body,
                                chat_group_id: message.chat_group_id,
                                chat_message_id: message.chat_message_id,
                                created_by: message.from,
                                s3_keys: documents,
                                chat_at: message.chat_at,
                            }
                        ]
                    }
                    //  add into groupChats and groupChatsArray
                    setGroupChats(prev => [newGroupChat, ...prev])
                    setGroupChatsArray(prev => [newChatGroupArray, ...prev])
                } else {
                    const chatGroup = groupChatsArray.find(chat => chat.chat_group_id === message.chat_group_id)
                    const newMessage = { type: 'received', message: message.message_body }
                    chatGroup?.message?.push(newMessage)
                    let chatGroupListArray = groupChats
                    let newChat = chatGroupListArray?.find(chat => chat.chat_group_id === message.chat_group_id)
                    newChat.new_message_sent = true
                    newChat.unread_count = newChat.unread_count + 1
                    const finalChatGroupList = [newChat, ...(chatGroupListArray?.filter(chat => chat.chat_group_id !== message.chat_group_id))]
                    setGroupChats(finalChatGroupList)
                    setGroupChatsArray(prev => [chatGroup, ...prev?.filter(chat => chat.chat_group_id !== message.chat_group_id)])
                }
            }
        };
    }, [ws, isPaused, groupChatsArray, selectedChatUser, groupChats]);


    const sendReadReceipt = () => {
        // fetching last received message
        if (ws.current?.readyState === WebSocket.OPEN) {
            const reversedMessages = selectedChatUser?.message.slice()
            reversedMessages?.reverse()
            const lastReceivedMessage = reversedMessages?.find(message => message.type === 'received');
            const body = {
                "action": "sendMessage",
                "chat_group_id": lastReceivedMessage?.chat_group_id,
                "chat_message_id": lastReceivedMessage?.chat_message_id,
                "from_user_id": userId,
                "to_user_id": userId,
                "request_type_function": "update_message_receipt",
            }
            if (lastReceivedMessage?.chat_message_id) {
                ws.current.send(JSON.stringify(body));
            }
            messagesEndRef.current = null; //reset ref
        } else {
            console.error("WebSocket is not open. Cannot send message.");
        }

    };




    useEffect(() => {

        const messagesDiv = messagesRef.current;
        if (!messagesDiv) return;

        const handleScroll = () => {
            const atBottom = messagesDiv.scrollHeight - messagesDiv.scrollTop <= messagesDiv.clientHeight + 5;
            setIsAtBottom(atBottom);
        };

        messagesDiv.addEventListener("scroll", handleScroll);
        return () => messagesDiv.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToBottom = () => {
        setTimeout(() => {
            if (messagesRef.current) {
                messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
                sendReadReceipt();
            }
        }, 100);
    };

    useEffect(() => {
        const messagesDiv = messagesRef.current;
        if (!messagesDiv) return;

        // If the user is at the bottom, send a read receipt when a new message arrives
        if (isAtBottom) {
            sendReadReceipt();
            const reversedMessages = selectedChatUser?.message.slice()
            reversedMessages?.reverse()
            const lastReceivedMessage = reversedMessages?.find(message => message.type === 'received');
            if (lastReceivedMessage?.chat_message_id) {
                // ws.current.send(JSON.stringify(body));
                // update unread count
                const chat = unreadChatArray?.find(chat => chat.chat_group_id === lastReceivedMessage?.chat_group_id)
                if (chat) {
                    chat.unread_count = 0
                    setUnreadChatArray([...unreadChatArray.filter(chat => chat.chat_group_id !== lastReceivedMessage?.chat_group_id), chat])
                    setUnreadMessageCount(prev => prev - 1)
                }
                let unreadChatArrayDummy = unreadChatArray
                const chatIndex = unreadChatArrayDummy?.findIndex(chat => chat.chat_group_id === lastReceivedMessage?.chat_group_id)
                if (chatIndex > -1) {
                    unreadChatArrayDummy[chatIndex].unread_count = 0
                    setUnreadChatArray(unreadChatArrayDummy)
                }
                let totalUnreadCount = 0
                unreadChatArrayDummy?.forEach(chat => {
                    if (chat.unread_count > 0) {
                        totalUnreadCount = totalUnreadCount + 1
                    }
                })
                setUnreadMessageCount(totalUnreadCount)
                setUnreadChatArray(unreadChatArrayDummy)

            }
        }
        // Always scroll to the bottom if the user is already at the bottom
        messagesDiv.scrollTop = messagesDiv.scrollHeight;
    }, [newMessage, selectedChatUser]);

    useEffect(() => {
        if (groupChatsArray.length > 0 && onlineUsers.length > 0) {
            const groupChatsArrayWithOnlineStatus = groupChatsArray.map(group => {
                const onlineStatus = onlineUsers.includes(group.user_id)
                return {
                    ...group,
                    isOnline: onlineStatus
                }
            })
            setGroupChatsArray(groupChatsArrayWithOnlineStatus)
        }
    }, [onlineUsers])

    const fetchAllUsers = () => {
        dispatch(getAllUsersForChat(searchText))
    }


    const sendMessageToSocket = (toUser, textInput, group, isNewGroup) => {
        if (group?.chat_group_id) {
            // get last message from group with message type sent
            const lastSentMessages = [...group?.message]?.reverse()?.filter(message => message.type === 'sent');
            const lastsecondSentMessage = lastSentMessages.length > 1 ? lastSentMessages[1] : null;
            const lastSentMessage = lastSentMessages.length > 1 ? lastSentMessages[0] : null;
            const lastMessageDummyId = lastSentMessage?.message_dummy_id;
            // const message_dummy_id = lastMessageDummyId ? lastMessageDummyId + 1 : 1;
            if (ws.current?.readyState === WebSocket.OPEN) {
                const messagePayload = {
                    action: "sendMessage",
                    request_type_function: 'new_message',
                    message: `Hello from ${username}`,
                    message_body: textInput,
                    from: name,
                    from_id: userId,
                    to: toUser.name,
                    chat_group_id: group.chat_group_id,
                    group_username: group?.username,
                    new_group: isNewGroup,
                    message_dummy_id: lastMessageDummyId,
                };
                setIsLastSentMessageSeen(false)
                ws.current.send(JSON.stringify(messagePayload));
                setIsNewGroupChat(false)
            } else {
                console.error("WebSocket is not open. Cannot send message.");
            }
        } else {
            const data = {
                group_name: `${toUser.name}, ${name}`,
                description: 'One On One Chat',
                userId1: userId,
                userId2: toUser.user_id,
                sent_message: textInput
            }
            createAGroupChat(data)
        }
    }



    const createAGroupChat = async (details) => {
        setIsLoading(true)
        const body = {
            "chat_group_name": details.group_name,
            "description": details.description,
            "is_group_chat": 0,
            "creator_id": userId,
            "creator_name": name
        }
        axios.post(base_url + `social/group`, body)
            .then(async (res) => {
                const response = res.data.data
                const chat_group_id = response.chat_group_id
                const chatGroup = {
                    chat_group_name: details.group_name,
                    description: "One On One Chat",
                    "active_ind": 1,
                    "archived_ind": 0,
                    "deleted_ind": 0,
                    "creator_name": name,
                    "is_group_chat": 0,
                    chat_group_id: chat_group_id
                }

                const body = {
                    members: [
                        {
                            chat_group_id: chat_group_id,
                            user_id: details.userId1,
                            admin_flag: 0
                        },
                        {
                            chat_group_id: chat_group_id,
                            user_id: details.userId2,
                            admin_flag: 0
                        }
                    ]
                }
                setChatGroupId(chat_group_id)
                axios.post(base_url + `social/groupMembers`, body)
                    .then(async (res) => {
                        setIsLoading(false)
                        const response = res.data.data
                        const newGroupChat = {
                            name: chatGroup.chat_group_name,
                            username: chatGroup.chat_group_name,
                            chat_group_name: chatGroup.chat_group_name,
                            user_id: chatGroup.chat_group_id,
                            description: chatGroup.description,
                            chat_group_id: chatGroup.chat_group_id,
                            "active_ind": 1,
                            "archived_ind": 0,
                            "deleted_ind": 0,
                            "creator_name": name,
                            new_message_sent: false,
                        }
                        // const documents = await getDocuments(getS3Keys(details.sent_message))
                        const newChatGroupArray = {
                            name: chatGroup.chat_group_name,
                            username: chatGroup.chat_group_name,
                            chat_group_id: chatGroup.chat_group_id,
                            user_id: chatGroup.chat_group_id,
                            is_group_chat: 0,
                            message: [
                                {
                                    type: 'sent',
                                    message: parseMessage(details.sent_message),
                                    chat_group_id: chatGroup.chat_group_id,
                                    chat_message_id: null,
                                    created_by: name,
                                    s3_keys: null,
                                    time: new Date().toISOString()
                                }
                            ]
                        }
                        setSelectedChatUser(newChatGroupArray)
                        setGroupChatsArray(prev => [newChatGroupArray, ...prev])

                        setGroupChats(prev => [newGroupChat, ...prev])
                        setSelectedChat(0)
                        sendMessageToSocket(newGroupChat, details.sent_message, newChatGroupArray, true)
                    })
                    .then(() => {
                        fetchUserGroups()
                        const element = document.getElementById("recent-chats");
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                        }
                    })
                    .catch((err) => {
                        setErrorMsg(err.response.data.message)
                        setIsLoading(false)
                        const error = err.response.data.message
                        setErrorMsg(error)
                        setSelectedChatUser(null)
                    })
            })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                setIsLoading(false)
                dispatch({
                    type: GET_ALL_USERS_ERROR,
                    payload: err.response.data.message
                })
            })
    }

    const encryptToken = (token, secretKey) => {
        // return CryptoJS.AES.encrypt(token, secretKey).toString();
        return token;
    };

    const sendMessageMethod = async () => {
        let capturedImageS3Keys = []
        let files = []
        if (capturedImage) {
            setIsLoading(true)
            files = [
                {
                    file_content: capturedImage.split(",")[1],
                    file_name: "image.jpg",
                    file_type: "jpg",
                    object_type: "chat_document",
                    flag: null,
                    file_description: 'This is a captured image',
                    user_id: localStorage.getItem("username"),
                    chat_group_id: selectedChatUser?.chat_group_id
                }
            ]
            await axios.post(base_url + `documents`, { "files": files })
                .then((res) => {
                    capturedImageS3Keys = res.data.data
                    setUploadedS3Keys([...res.data.data])
                    setIsLoading(false)
                })
                .catch((err) => {
                    setErrorMsg(err.response.data.message)
                    setIsLoading(false)
                })
        }
        const trimmedText = textInput.trim()
        let json_message = JSON.stringify({ message: trimmedText, s3_keys: uploadedS3Keys.length > 0 ? uploadedS3Keys : null })
        if (trimmedText !== '') {
            const newMessage = {
                type: 'sent',
                message: textInput,
                time: new Date().toISOString(),
                s3_keys: capturedImage ? files.map(file => ({ file: file.file_content, file_name: file.file_name, file_type: file.file_type })) : selectedFilesData ? selectedFilesData?.map(file => ({ file: file.file_content, file_name: file.file_name, file_type: file.file_type })) : [],
                chat_group_id: selectedChatUser?.chat_group_id,
                chat_message_id: null,
                created_by: name,
                message_dummy_id: selectedChatUser?.message?.length + 1
            }
            setAllChats({
                ...allChats, [selectedChatUser?.chat_group_id]: {
                    chat_group_id: selectedChatUser?.chat_group_id,
                    name: selectedChatUser?.name,
                    username: selectedChatUser?.username,
                    user_id: selectedChatUser?.user_id,
                    is_group_chat: selectedChatUser?.is_group_chat,
                    message: [...selectedChatUser?.message, newMessage]
                }
            });
            const newChatsArray = selectedChatUser?.message
            newChatsArray.push(newMessage)
            setChatsArray(prevChats => prevChats.map(chat =>
                chat.name === selectedChatUser.name ?
                    { ...chat, message: [...chat.message, newMessage] }
                    : chat
            ));
            sendMessageToSocket(selectedChatUser, json_message, selectedChatUser, isNewGroupChat)
            setTextInput('')
        }
        setUploadedS3Keys([])
        setDocumentsUpload(false)
        setSelectedFiles([])
        setTextInput('')
        setSelectedFilesData([])
        scrollToBottom()
        capturedImage && setCapturedImage(null)
        capturedImage && setShowCamera(false)
    }

    const fetchUserGroups = () => {
        setIsLoading(true)
        axios.get(base_url + `social/groupsForUser?search_text=${searchText}`, {
            params: {
                filter_condition: JSON.stringify({
                    user_id: localStorage.getItem('user_id')
                })
            }
        })
            .then((res) => {
                setIsLoading(false)
                let response = res.data.data
                response?.forEach(group => {
                    group.new_message_sent = false;
                    group.unread_count = 0;
                });
                // setChatGroupList(response)
                if (unreadCountArray.length > 0) {
                    response.forEach(group => {
                        const chatGroup = unreadCountArray.find(chat => chat.chat_group_id === group.chat_group_id)
                        if (chatGroup) {
                            group.new_message_sent = true
                            group.unread_count = chatGroup.unread_count
                        }
                    })
                }
                setGroupChats(response.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)))
                const groupChats = response.map(group => ({
                    name: group.chat_group_name,
                    username: group.chat_group_name,
                    chat_group_id: group.chat_group_id,
                    user_id: group.chat_group_members_id,
                    message: [],
                }));

                setGroupChatsArray(groupChats)
            })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                setIsLoading(false)
                console.log(err)
            })
    }

    const fetchOnlineStatus = () => {
        axios.get(base_url + `social/connections`)
            .then((res) => {
                const response = res.data.data
                let onlineUsersArray = []
                response.forEach(user => {
                    if (user?.user_id) {
                        onlineUsersArray.push(user.user_id)
                    }
                })
                setOnlineUsers(onlineUsersArray)
            })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                console.log(err)
            })
    }

    const getInitials = (name) => {
        return name?.split(' ')
            ?.map(word => word[0]?.toUpperCase())
            ?.join('')?.substring(0, 2)
    };

    const parseMessage = (message) => {
        try {
            const parsedMessage = JSON.parse(message)
            if (parsedMessage?.message) {
                return parsedMessage?.message
            } else {
                return message
            }
        } catch (error) {
            return message
        }
    }

    const getS3Keys = (message) => {
        try {
            let keys = [];
            const parsedMessage = JSON.parse(message);
            if (parsedMessage?.s3_keys) {
                keys = parsedMessage?.s3_keys.map(keyObj => keyObj.key);
            }
            return keys;
        } catch (error) {
            return [];
        }
    };

    const getDocuments = async (s3_keys) => {
        let base64_obj_list = [];
        if (s3_keys) {
            try {
                const res = await axios.get(base_url + `documents?filter_condition=${encodeURIComponent(JSON.stringify({ "s3_keys": s3_keys }))}`);
                base64_obj_list = res.data.data;
            } catch (err) {
                console.log(err);
            }
        }
        return base64_obj_list;
    };

    const getChatForGroup = async (group, openChat = true) => {
        if (allChats[group?.chat_group_id]) {
            setSelectedChatUser(allChats[group?.chat_group_id])
            scrollToBottom()
            setIsChatUserOnline(onlineUsers.includes(groupMembers[group?.chat_group_id]));
        } else {
            openChat && setIsLoading(true);
            let filter_condition = JSON.stringify({
                chat_group_id: group?.chat_group_id
            });
            filter_condition = encodeURIComponent(filter_condition);
            try {
                const res = await axios.get(base_url + `social/messages?filter_condition=${filter_condition}&page_number=1&items_per_page=${limit}&request_type="dropdown"`);
                const messages = res.data.data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

                // Collect all s3 keys
                let allS3Keys = [];
                messages.forEach(message => {
                    const s3_keys = getS3Keys(message?.message_json);
                    allS3Keys = [...allS3Keys, ...s3_keys];
                });

                // Fetch all documents in a single call
                let documents = [];
                if (allS3Keys.length > 0) {
                    documents = await getDocuments(allS3Keys);
                }

                // Create a key-value pair for s3 keys and their corresponding documents
                const s3KeyDocumentMap = {};
                allS3Keys.forEach((key, index) => {
                    s3KeyDocumentMap[key] = {
                        file: documents[index].file,
                        file_name: documents[index].file_name,
                        file_type: documents[index].file_type
                    };
                });


                const parsedMessages = messages.map(message => {
                    const s3_keys = getS3Keys(message?.message_json);
                    const documentObjects = s3_keys.map(key => s3KeyDocumentMap[key] || null).filter(doc => doc !== null);
                    return {
                        type: message.from_id === userId ? 'sent' : 'received',
                        message: parseMessage(message?.message_json),
                        time: message?.created_at,
                        chat_group_id: message.chat_group_id,
                        chat_message_id: message.chat_message_id,
                        s3_keys: documentObjects,
                        created_by: message.created_by,
                        message_dummy_id: null,
                    };
                });

                // get last sent message
                const lastSentMessages = [...parsedMessages]?.reverse()?.filter(message => message.type === 'sent');
                const lastSentMessage = lastSentMessages.length > 1 ? lastSentMessages[0] : null;
                if (lastSentMessage) {
                    openChat && setIsLoading(true);
                    axios.get(base_url + `social/messagesWithTrack`, {
                        params: {
                            filter_condition: JSON.stringify({
                                "message_id": lastSentMessage?.chat_message_id
                            })
                        }
                    })
                        .then((res) => {
                            const response = res.data.data[0]
                            if (response?.seen_at) {
                                setIsLastSentMessageSeen(true)
                            } else {
                                setIsLastSentMessageSeen(false)
                            }
                            openChat && setIsLoading(false)

                        })
                        .catch((err) => {
                            openChat && setIsLoading(false)
                            console.log(err)
                        })
                }


                setShowGroupMembers(false)
                setIsChatUserOnline(false)
                getAllGroupMembers1(group?.chat_group_id)

                setAllChats({
                    ...allChats, [group?.chat_group_id]: {
                        chat_group_id: group?.chat_group_id,
                        name: group?.chat_group_name,
                        username: group?.chat_group_name,
                        user_id: group?.chat_group_id,
                        is_group_chat: group?.is_group_chat,
                        message: parsedMessages
                    }
                });

                openChat && setSelectedChatUser({
                    chat_group_id: group?.chat_group_id,
                    name: group?.chat_group_name,
                    username: group?.chat_group_name,
                    user_id: group?.chat_group_id,
                    is_group_chat: group?.is_group_chat,
                    message: parsedMessages
                });
                scrollToBottom();
                openChat && setIsLoading(false);
            } catch (err) {
                openChat && setIsLoading(false);
                console.log(err);
            }
        }
    };


    const uploadDocumentFiles = (files) => {
        const processedFiles = [];
        Array.from(files)?.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = function () {
                const base64FileContent = reader.result.split(",")[1];
                const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
                const processedFile = {
                    file_content: base64FileContent,
                    file_name: file.name,
                    file_type: fileExtension,
                    object_type: "chat_document",
                    flag: null,
                    file_description: 'This is a sample amc document',
                    user_id: localStorage.getItem("username"),
                    chat_group_id: selectedChatUser?.chat_group_id
                };
                processedFiles.push(processedFile);
                if (processedFiles.length === files.length) {
                    // setFileData(processedFiles);
                    axios.post(base_url + `documents`, { "files": processedFiles })
                        .then((res) => {
                            setUploadedS3Keys([...res.data.data])
                        })
                        .catch((err) => {
                            setErrorMsg(err.response.data.message)
                        })
                }
            };
            reader.readAsDataURL(file);
        });
        setSelectedFilesData(processedFiles);
    }

    const createAGroupChatforGroup = () => {
        setIsLoading(true)
        const body = {
            "chat_group_name": groupChatName,
            "description": groupChatDescription,
            "is_group_chat": 1,
            "creator_id": userId,
            "creator_name": name
        }
        axios.post(base_url + `social/group`, body)
            .then(async (res) => {
                const response = res.data.data
                const chat_group_id = response.chat_group_id
                const chatGroup = {
                    chat_group_name: groupChatName,
                    description: groupChatDescription,
                    "active_ind": 1,
                    "archived_ind": 0,
                    is_group_chat: 1,
                    "deleted_ind": 0,
                    "creator_name": name,
                    chat_group_id: chat_group_id
                }

                const groupMembers = groupChatMembersArray.map(member => ({
                    chat_group_id: chat_group_id,
                    user_id: member.user_id,
                    admin_flag: 0
                }))

                const body = {
                    members: [...groupMembers, {
                        chat_group_id: chat_group_id,
                        user_id: userId,
                        admin_flag: 1
                    }]
                }
                setChatGroupId(chat_group_id)
                axios.post(base_url + `social/groupMembers`, body)
                    .then((res) => {
                        setIsLoading(false)
                        const response = res.data.data
                        const newGroupChat = {
                            name: chatGroup.chat_group_name,
                            username: chatGroup.chat_group_name,
                            chat_group_name: chatGroup.chat_group_name,
                            user_id: chatGroup.chat_group_id,
                            description: chatGroup.description,
                            chat_group_id: chatGroup.chat_group_id,
                            "active_ind": 1,
                            "archived_ind": 0,
                            "deleted_ind": 0,
                            "creator_name": name,
                            new_message_sent: false,
                        }
                        const newChatGroupArray = {
                            name: chatGroup.chat_group_name,
                            username: chatGroup.chat_group_name,
                            chat_group_id: chatGroup.chat_group_id,
                            user_id: chatGroup.chat_group_id,
                            is_group_chat: 1,
                            message: []
                        }
                        setSelectedChatUser(newChatGroupArray)
                        setIsNewGroupChat(true)
                        setGroupChatsArray(prev => [newChatGroupArray, ...prev])
                        setGroupChats(prev => [newGroupChat, ...prev])
                        setSelectedChat(0)
                        // setChatGroupList(prev => [newGroupChat, ...prev])
                        setIsGroupChatButtonClicked(false)
                        setIsGroupChatNextClicked(false)
                        setGroupChatMembersArray([])
                        setGroupChatName('')
                        setGroupChatDescription('')
                    })
                    .then(() => {
                        fetchUserGroups()
                        const element = document.getElementById("recent-chats");
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                        }
                    })
                    .catch((err) => {
                        setErrorMsg(err.response.data.message)
                        setIsLoading(false)
                        console.log(err)
                    })
            })
            .catch((err) => {
                setIsLoading(false)
                dispatch({
                    type: GET_ALL_USERS_ERROR,
                    payload: err.response.data.message
                })
            })
    }

    const getAllGroupMembers = (chatGroupId) => {
        setIsLoading(true)
        axios.get(base_url + `social/groupMembers`, {
            params: {
                filter_condition: JSON.stringify({
                    chat_group_id: chatGroupId
                })
            }
        }).then((res) => {
            setIsLoading(false)
            const response = res.data.data
            setGroupChatMembersArray(response)
            // remove members from userlist 
            const groupChatMemberAdding = response.map(member => member.user_id)
            // get other user 
            const chatUserId = groupChatMemberAdding.find(member => member.user_id == userId)
            setMembersIdInGroup(chatUserId)
            const usersWithchatsForGroup = usersList?.filter(user => !groupChatMemberAdding.includes(user.user_id))
            setAllUsersWithChatsForGroup(usersWithchatsForGroup)

            setShowGroupMembers(true)

            // setAddGroupMemberModalClicked(true)
        })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                setIsLoading(false)
                console.log(err)
            })
    }

    const getAllGroupMembers1 = (chatGroupId) => {
        setIsLoading(true)
        axios.get(base_url + `social/groupMembers`, {
            params: {
                filter_condition: JSON.stringify({
                    chat_group_id: chatGroupId
                })
            }
        }).then((res) => {
            setIsLoading(false)
            const response = res.data.data
            setGroupChatMembersArray(response)
            // remove members from userlist 
            const groupChatMemberAdding = response.map(member => member.user_id)
            const groupChatMember = groupChatMemberAdding.find(member => member !== userId)
            const isOnline = onlineUsers.includes(groupChatMember)
            setGroupMembers({ ...groupMembers, [chatGroupId]: groupChatMember })
            if (!selectedChatUser?.is_group_chat) {
                setIsChatUserOnline(isOnline)
                setChatMemberId(groupChatMember)
            } else {
                setIsChatUserOnline(false)
                setChatMemberId(null)
            }
            // get other user 
            const chatUserId = groupChatMemberAdding.find(member => member.user_id == userId)
            setMembersIdInGroup(chatUserId)
            const usersWithchatsForGroup = usersList?.filter(user => !groupChatMemberAdding.includes(user.user_id))
            setAllUsersWithChatsForGroup(usersWithchatsForGroup)
        })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                setIsLoading(false)
                console.log(err)
            })
    }

    const deleteMemberFromGroup = (member) => {
        setIsLoading(true)
        const body = {
            "chat_group_members_id": member.chat_group_members_id,
            "left": true,
            "removed": true,
        }
        axios.delete(base_url + `social/groupMembers`, {
            data: body
        })
            .then(() => {
                const newGroupChatMembers = groupChatMembersArray.filter(user => user.user_id !== member.user_id)
                setGroupChatMembersArray(newGroupChatMembers)
                setAllUsersWithChatsForGroup(prev => [...prev, member])
                setIsLoading(false)
                let json_message = JSON.stringify({ message: `rapture@2(3.5)istoughlife-> ${name} removed ${member?.name}`, s3_keys: null })
                sendMessageToSocket(selectedChatUser, json_message, selectedChatUser, isNewGroupChat)
                // add this to chat messages
                setSelectedChatUser(prev => ({
                    ...prev,
                    message: [...prev.message, {
                        type: 'sent',
                        message: `rapture@2(3.5)istoughlife-> ${name} removed ${member?.name}`,
                        time: new Date().toISOString(),
                        chat_group_id: selectedChatUser?.chat_group_id,
                        chat_message_id: null,
                        created_by: member?.name
                    }]
                }))
            })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                console.log(err)
                setIsLoading(false)
            })
    }

    const leaveAGroup = (member) => {
        setIsLoading(true)
        const body = {
            "chat_group_members_id": member.chat_group_members_id,
            "left": true,
            "removed": false,
        }
        let json_message = JSON.stringify({ message: `rapture@2(3.5)istoughlife-> ${member?.name} left the group`, s3_keys: null })
        sendMessageToSocket(selectedChatUser, json_message, selectedChatUser, isNewGroupChat)
        // add this to chat messages
        setSelectedChatUser(prev => ({
            ...prev,
            message: [...prev.message, {
                type: 'sent',
                message: `rapture@2(3.5)istoughlife-> ${member?.name} left the group`,
                time: new Date().toISOString(),
                chat_group_id: selectedChatUser?.chat_group_id,
                chat_message_id: null,
                created_by: member?.name
            }]
        }))
        axios.delete(base_url + `social/groupMembers`, {
            data: body
        })
            .then(() => {
                const newGroupChatMembers = groupChatMembersArray.filter(user => user.user_id !== member.user_id)
                setGroupChatMembersArray(newGroupChatMembers)
                setAllUsersWithChatsForGroup(prev => [...prev, member])
                setSelectedChatUser(null)
                setIsLoading(false)
                setGroupChats(prev => prev.filter(chat => chat.chat_group_id !== selectedChatUser?.chat_group_id))
                setGroupChatsArray(prev => prev.filter(chat => chat.chat_group_id !== selectedChatUser?.chat_group_id))

            })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                console.log(err)
                setIsLoading(false)
            })
    }

    const addNewMembersToGroup = (user) => {
        const groupChatMember = {
            chat_group_id: selectedChatUser?.chat_group_id,
            user_id: user.user_id,
            admin_flag: 0
        }
        const body = {
            members: [groupChatMember]
        }
        let json_message = JSON.stringify({ message: `rapture@2(3.5)istoughlife-> ${name} added ${user?.name}`, s3_keys: null })
        sendMessageToSocket(selectedChatUser, json_message, selectedChatUser, isNewGroupChat)
        // add this to chat messages
        setSelectedChatUser(prev => ({
            ...prev,
            message: [...prev.message, {
                type: 'sent',
                message: `rapture@2(3.5)istoughlife-> ${name} added ${user?.name}`,
                time: new Date().toISOString(),
                chat_group_id: selectedChatUser?.chat_group_id,
                chat_message_id: null,
                created_by: name
            }]
        }))
        setIsLoading(true)
        axios.post(base_url + `social/groupMembers`, body)
            .then((res) => {
                const response = res.data.data
                const data = response[0]
                let newData = user
                user['chat_group_members_id'] = data.chat_group_members_id
                const newGroupChatMembers = [...groupChatMembersArray, newData]
                setGroupChatMembersArray(newGroupChatMembers)
                const newMembers = allUsersWithChatsForGroup.filter(member => member.user_id !== user.user_id)
                setAllUsersWithChatsForGroup(newMembers)
                setIsLoading(false)
            })
            .catch((err) => {
                setErrorMsg(err.response.data.message)
                setIsLoading(false)
                console.log(err)
            })
    }

    const handleScroll = (e) => {
        if (selectedChatGroup) {
            let last_seen_message = selectedChatUser?.message[0]?.chat_message_id;
            if (messagesRef?.current?.scrollTop === 0 && hasMore) {
                const page = pageNumber + 1;
                setIsLoading(true);
                let filter_condition = JSON.stringify({
                    chat_group_id: selectedChatUser?.chat_group_id
                });
                filter_condition = encodeURIComponent(filter_condition);
                axios.get(base_url + `social/messages?filter_condition=${filter_condition}&page_number=${page}&items_per_page=${limit}&request_type="dropdown"`)
                    .then(async (res) => {
                        res.data.data.length === 0 && setHasMore(false);
                        const newMessages = res.data.data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                        let allS3Keys = [];
                        newMessages.forEach(message => {
                            const s3_keys = getS3Keys(message?.message_json);
                            allS3Keys = [...allS3Keys, ...s3_keys];
                        });

                        let documents = [];
                        if (allS3Keys.length > 0) {
                            documents = await getDocuments(allS3Keys);
                        }

                        const s3KeyDocumentMap = {};
                        allS3Keys.forEach((key, index) => {
                            s3KeyDocumentMap[key] = {
                                file: documents[index].file,
                                file_name: documents[index].file_name,
                                file_type: documents[index].file_type
                            };
                        });

                        const parsedMessages = newMessages.map(message => {
                            const s3_keys = getS3Keys(message?.message_json);
                            const documentObjects = s3_keys.map(key => s3KeyDocumentMap[key] || null).filter(doc => doc !== null);
                            return {
                                type: message.from_id === userId ? 'sent' : 'received',
                                message: parseMessage(message?.message_json),
                                time: message?.created_at,
                                chat_group_id: message.chat_group_id,
                                chat_message_id: message.chat_message_id,
                                s3_keys: documentObjects,
                                created_by: message.created_by
                            };
                        });

                        setSelectedChatUser(prev => ({
                            ...prev,
                            message: [...parsedMessages, ...prev.message]
                        }));
                        setPageNumber(page);
                        setIsLoading(false);
                    })
                    .then(() => {
                        setTimeout(() => {
                            const element = document.getElementById(last_seen_message);
                            if (element) {
                                element.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center"
                                });
                            }
                        }, 100);
                    })
                    .catch((err) => {
                        setIsLoading(false);
                        console.log(err);
                    });
            }
        }
    }

    const getUserName = (selectedChat) => {
        let filteredGroupName = ''
        if (selectedChat?.name) {
            const groupMembers = selectedChat?.name?.split(', ')
            const username = groupMembers.filter(member => member !== name).join(', ')
            filteredGroupName = username
        }

        return filteredGroupName
    }
    const videoConstraints = {
        // Use 'user' for front camera, 'environment' for back camera
        facingMode: cameraView,
    };

    const changeCameraView = () => {
        setCameraView(cameraView === 'user' ? 'environment' : 'user');
    }

    const capturePhoto = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        setCapturedImage(imageSrc);
    }

    const chatWindowContent = () => {


        return <div className="chat-window">
            {selectedChatUser ? (
                <div className="chat-content">
                    <div className="d-flex justify-content-between gap-2 align-items-center specific-chat-header p-2 px-sm-1">
                        <div className='d-flex align-items-center gap-2'>
                            {mobileChatWindow && <IoArrowBack className='C-pointer' onClick={() => {
                                setMobileChatWindow(false)
                                setSelectedChatUser(null)
                            }} style={{ height: "20", width: "20" }} />}
                            {/* <h5 style={{ margin: "0px", padding: "0px" }}>{selectedChatUser?.name}</h5> */}
                            <div style={{ marginLeft: '10px', backgroundColor: "#706D6D", width: "40px", height: "40px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: "15px" }}>
                                {getInitials(getUserName(selectedChatUser))}
                            </div>

                            {!selectedChatUser?.is_group_chat ?
                                isChatUserOnline ? <FaCircle style={{ color: "green", marginLeft: "-20px", marginTop: 'auto', marginBottom: '5px', border: "2px solid lightgray", borderRadius: "50%" }} /> : ''
                                : ''
                            }
                            <h5 style={{ margin: "0px", padding: "0px" }}>{getUserName(selectedChatUser)}</h5>

                            <div className='d-flex justify-content-between mx-5'>
                                <div className="d-flex align-items-center" >
                                    <div className="chat-icon-header C-pointer"
                                        onClick={() => setSpecificChatType('chat')}>
                                        <h6 style={{ textDecoration: specificChatType === 'chat' ? 'underline' : 'none' }}>Chats</h6>
                                    </div>
                                    <div className="chat-icon-header C-pointer"
                                        onClick={() => setSpecificChatType('files')}>
                                        <h6 style={{ textDecoration: specificChatType === 'files' ? 'underline' : 'none' }}>Shared</h6>
                                    </div>
                                </div>

                            </div>

                        </div>
                        {selectedChatUser?.is_group_chat ? <div className='C-pointer mx-3'

                        >
                            <MdGroupAdd style={{
                                height: '25px',
                                width: '25px',
                                color: 'gray',
                                marginRight: '10px'
                            }}
                                onClick={() => {
                                    // setAddGroupMemberModalClicked(true)
                                    getAllGroupMembers(selectedChatUser?.chat_group_id)
                                }}
                            />
                            {showGroupMembers && <div style={{ position: "relative" }}
                            >
                                <div
                                    className='show-group-members'
                                    style={{ position: 'absolute', right: 0 }}>
                                    <div>
                                        {/* close button */}
                                        <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                                            <div>Group Members</div>
                                            <IoClose className='C-pointer' onClick={() => setShowGroupMembers(false)} />
                                        </div>
                                    </div>
                                    {groupChatMembersArray.map((user, index) => {
                                        return (
                                            <div key={index}
                                                className='d-flex justify-content-start align-items-center gap-2 py-2'
                                                style={{ padding: '2px', borderBottom: '1px solid #9D9D9C' }}>
                                                <div style={{
                                                    backgroundColor: "#706D6D",
                                                    width: "25px", height: "25px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: "12px"
                                                }}>
                                                    {getInitials(user?.name ? user?.name : '')}
                                                </div>
                                                <div>{user?.name}</div>
                                            </div>
                                        )
                                    })}
                                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                        <p className='leave-group-button C-pointer'
                                            onClick={() => {
                                                setAddGroupMemberModalClicked(true)
                                            }}
                                        >
                                            Add Group Members
                                        </p>
                                        <p className='leave-group-button C-pointer' onClick={() => {
                                            // setAddGroupMemberModalClicked(true)
                                            // member details
                                            const member = groupChatMembersArray.find(member => member.user_id === userId);
                                            setMemberToLeave(member);
                                            setShowLeaveGroupConfirm(true);
                                        }}>
                                            Leave Group
                                        </p>
                                    </div>
                                </div>
                            </div>}
                        </div> : null}
                    </div>
                    <div className="messages" ref={messagesRef} onScroll={handleScroll}>
                        <div>
                            {selectedChatUser?.message.map((message, index) => {
                                const messageDate = new Date(message?.time);
                                const today = new Date();
                                const yesterday = new Date(today);
                                yesterday.setDate(today.getDate() - 1);
                                let displayDate = messageDate.toLocaleDateString().replace(/\//g, '-');

                                if (messageDate.toDateString() === today.toDateString()) {
                                    displayDate = "Today";
                                } else if (messageDate.toDateString() === yesterday.toDateString()) {
                                    displayDate = "Yesterday";
                                }

                                const showDate = index === 0 || new Date(selectedChatUser?.message[index - 1]?.time).toDateString() !== messageDate.toDateString();
                                const localTime = new Date(convertUTCToLocal(message?.time)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                                const sentUserName = message?.created_by
                                const sentBySameUser = selectedChatUser?.message[index - 1]?.created_by === sentUserName

                                // get Last message which is type === 'sent' 
                                const sentMessageArray = selectedChatUser?.message.filter(message => message.type === 'sent')
                                const lastSentMessage = sentMessageArray[sentMessageArray?.length - 1]
                                const isLastSentMessage = lastSentMessage?.chat_message_id === message?.chat_message_id

                                return (
                                    <React.Fragment key={index}>
                                        {showDate && <div style={{ textAlign: "center", position: "sticky", top: 0, zIndex: 1 }}>
                                            <div style={{ backgroundColor: "#9D9D9C", color: "white", padding: "8px", borderRadius: "5px", fontSize: "12px", display: "inline-block" }}>
                                                {displayDate}
                                            </div>
                                        </div>}
                                        {message?.message.startsWith('rapture@2(3.5)istoughlife->') ?
                                            <div className='d-flex justify-content-center'>
                                                <div className='chat-bubble-left'>
                                                    <div>{message?.message.replace('rapture@2(3.5)istoughlife->', '')}</div>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                {message?.type !== "sent" && !sentBySameUser &&
                                                    <p
                                                        className='sent-message-name'
                                                    >{message?.created_by}</p>
                                                }
                                                <div style={{ position: "relative" }}
                                                    id={message?.chat_message_id}
                                                    // ref={index === selectedChatUser?.message?.length - 1 ? messagesEndRef : null} //
                                                    className={message.type === 'sent' ? "sent-message" : "received-message"}>
                                                    {/* <div style={{ backgroundColor: "#706D6D", width: "40px", height: "40px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: "15px" }}>
                                                                    {getInitials(message?.created_by ? message?.created_by : '')}
                                                                </div> */}

                                                    <div className={message.type === 'sent' ? "chat-bubble  sent" : "chat-bubble received"}>
                                                        {message?.s3_keys && message?.s3_keys?.length > 0 && (
                                                            <div className='d-flex flex-column gap-3'>
                                                                {message?.s3_keys?.map((key, index) => {
                                                                    const fileUrl = `data:image/png;base64,${key?.file?.replace(/^b'/, '').replace(/'$/, '')}`;
                                                                    return (
                                                                        <div key={index} style={{ maxWidth: "100px", maxHeight: "100px", margin: "5px" }}>
                                                                            {(key?.file_type === "png" || key?.file_type === "jpg" || key?.file_type === "jpeg") ? (
                                                                                <img src={fileUrl} alt="document" style={{ width: "100px", height: "100px", backgroundSize: "cover" }}
                                                                                    onClick={() => {
                                                                                        setViewImage({ file: fileUrl, file_name: key?.file_name })
                                                                                    }}
                                                                                />
                                                                            ) : key?.file_type === "pdf" ? (
                                                                                <div onClick={() => {
                                                                                    const link = document.createElement('a');
                                                                                    link.href = fileUrl;
                                                                                    link.download = key?.file_name + ".pdf";
                                                                                    document.body.appendChild(link);
                                                                                    link.click();
                                                                                    document.body.removeChild(link);
                                                                                }
                                                                                }>
                                                                                    <GrDocumentPdf size={40} /> <p>{key?.file_name}</p>
                                                                                </div>
                                                                            ) : <div>
                                                                                <p>{key?.file_name}</p>
                                                                            </div>
                                                                            }
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                        <div className='px-1'>
                                                            {message.message}

                                                        </div>
                                                        <span style={{ position: "absolute", bottom: "5px", right: "10px", fontSize: "10px", color: "grey" }}>
                                                            {localTime}
                                                        </span>

                                                    </div>
                                                    {isLastSentMessage && <div className='d-flex justify-content-end' style={{ marginTop: '-20px' }}>
                                                        {isLastSentMessageSeen ? <FaEye style={{ color: 'gray', height: '15px', width: '15px' }} /> :
                                                            <FaRegCheckCircle style={{ color: 'gray', height: '15px', width: '15px' }} />}
                                                    </div>}
                                                </div>
                                            </>
                                        }
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                    <div className="chat-input">
                        <div className='chat-input-container'>
                            <input type="text" placeholder="Type a message..."
                                value={textInput}
                                onChange={(e) => {
                                    setTextInput(e.target.value)
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        sendMessageMethod()
                                    }
                                }
                                }
                            />
                            <div className='C-pointer' style={{ position: "relative" }}>
                                <IoAdd style={{ height: "30px", width: "30px" }} onClick={() => setDocumentsUpload(!documentsUpload)} />
                                {documentsUpload && <div className='d-flex flex-column gap-2' style={{ position: "absolute", bottom: "30px", zIndex: "10000000000", backgroundColor: "white", border: "1px solid #9D9D9C", padding: "10px", borderRadius: "5px" }}>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <img src='./images/icons/Camera.svg' alt='camera' style={{ height: "15px", width: "15px" }} />
                                        <div>Camera</div>
                                    </div>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <label htmlFor="file-upload" className='d-flex gap-2 align-items-center' style={{ cursor: "pointer" }}>
                                            <img src='./images/icons/AttachFile.svg' alt='gallery' style={{ height: "15px", width: "15px" }} />
                                            <div>Attach Files</div>
                                        </label>
                                        <input id="file-upload" type="file"
                                            style={{ display: "none" }} onChange={(e) => {
                                                const files = e.target.files;
                                                if (files) {
                                                    setSelectedFiles(files);
                                                    uploadDocumentFiles(files);
                                                    // Handle the selected file here
                                                }
                                            }} />
                                    </div>
                                    {selectedFiles.length > 0 &&
                                        <Modal show={true} centered onHide={() => setSelectedFiles([])}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Selected Files</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className='d-flex gap-2'>
                                                    <ul>
                                                        {Array.from(selectedFiles).map((file, index) => (
                                                            <li key={index}>{file.name}</li>
                                                        ))}
                                                    </ul>
                                                    {uploadedS3Keys.length == 0 && <div>
                                                        <Spinner animation="border" role="status" style={{ height: "20px", width: "20px", borderWidth: "1px" }}>
                                                            <span className="visually-hidden">Loading...</span>
                                                        </Spinner>
                                                    </div>}
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <div className="chat-input w-100">
                                                    <div className='chat-input-container'>
                                                        <input type="text" placeholder="Type a message..."
                                                            value={textInput}
                                                            onChange={(e) => {
                                                                setTextInput(e.target.value)
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    sendMessageMethod()
                                                                }
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                    <div className='send-icon C-pointer'>
                                                        <VscSend style={{ height: "20px", width: "20px" }}
                                                            onClick={() => {
                                                                sendMessageMethod()
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </Modal.Footer>
                                        </Modal>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        <div className='send-icon C-pointer'>
                            <VscSend style={{ height: "20px", width: "20px" }}
                                onClick={() => {
                                    sendMessageMethod()
                                }}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="no-chat" style={{ textAlign: "center" }}>Select a chat to start messaging</div>
            )}
        </div>
    }


    return (
        <>
            {isLoading && <Loader />}
            {loading && <Loader />}

            {contractApiLoader && <Loader />}
            <div>
                <div style={{ backgroundColor: "#706D6D", height: '50px' }} className='d-flex justify-content-between align-items-center px-3'>
                    <div style={{ backgroundColor: "white", padding: "2px 8px", fontSize: "10px", borderRadius: "8px" }} className='d-flex justify-content-center align-items-center gap-1'>
                        <div style={{ height: "6px", width: "6px", backgroundColor: webSocketConnection ? "green" : "red", borderRadius: "50%" }}></div>
                        {webSocketConnection ?
                            <div style={{ color: "green" }}>
                                online
                            </div> :
                            <div style={{ color: "red" }}>
                                offline
                            </div>}
                    </div>
                    <IoClose className='C-pointer' onClick={() => {
                        setViewChat(false)

                    }} style={{ color: "white", height: "30", width: "30" }} />
                </div>
                <div className="chat-container">
                    {/* Sidebar */}
                    {mobileChatWindow ? chatWindowContent() : <div className="chat-sidebar">
                        <div className='chat-sidebar-header'>
                            <div className="d-flex justify-content-between align-items-center gap-4">
                                <div className="chat-icon-header C-pointer"
                                    onClick={() => setChatType('chat')}>
                                    <h5>{isGroupChatButtonClicked ? "New Group chat" : "Chats"}</h5>
                                </div>
                                <div className=" C-pointer mr-3"
                                    onClick={() => {
                                        setIsGroupChatButtonClicked(!isGroupChatButtonClicked)
                                        // if (isGroupChatButtonClicked) {
                                        setIsGroupChatNextClicked(false)
                                        setGroupChatMembersArray([])
                                        setGroupChatName('')
                                        setGroupChatDescription('')
                                        // }
                                    }}>
                                    {!isGroupChatButtonClicked ? <RiChatNewFill style={{ width: '25px', height: '25px', marginRight: '3px' }} /> :
                                        <CiCircleRemove style={{ width: '25px', height: '25px', marginRight: '3px' }} />
                                    }
                                </div>
                            </div>
                            {!isGroupChatNextClicked && <div style={{ position: 'relative' }}>
                                <GoSearch className='search-icon' style={{ position: 'absolute', left: "10px", top: "14px" }} />
                                <input type="Search" placeholder="Search or start a new chat" className='social-search-bar' value={searchText} onChange={(e) => {
                                    setSearchText(e.target.value)
                                }} />
                            </div>}
                        </div>
                        {!isGroupChatButtonClicked ? <div className="chat-list-scroll">
                            <div style={{ width: "100%", padding: "0px", margin: "0px !important" }} className='mt-3 d-flex justify-content-between C-pointer px-2' onClick={() => setMinimizeRecentChats(!minimizeRecentChats)}>
                                <div id='recent-chats'>Recent Chats</div>
                                <img
                                    src={'./images/icons/RightArrow.svg'}
                                    alt={minimizeRecentChats ? "Down arrow" : "Right arrow"}
                                    className={`arrow ${minimizeRecentChats ? 'arrow-down' : 'arrow-right'}`}
                                />
                            </div>
                            {minimizeRecentChats && <ul className='mt-3 chat-list-item'>
                                {groupChats.map((group, index) => {

                                    let filteredGroupName
                                    if (!group?.is_group_chat) {
                                        const groupMembers = group?.chat_group_name?.split(', ')
                                        const username = groupMembers.filter(member => member !== name).join(', ')
                                        filteredGroupName = username
                                    } else {
                                        filteredGroupName = group?.chat_group_name
                                    }

                                    return (
                                        <li
                                            key={index}
                                            id={group?.chat_group_id}
                                            className={`${selectedChat === index ? "active" : ""} d-flex`}
                                            onClick={() => {
                                                setPageNumber(1)
                                                setHasMore(true)
                                                setSelectedChatGroup(group)
                                                getChatForGroup(group);
                                                minimizedChat && setMobileChatWindow(true)
                                                setSelectedChat(index)
                                                const chatGroupMapping = groupChats.map(chat => {
                                                    if (chat.chat_group_id === group.chat_group_id) {
                                                        chat.new_message_sent = false
                                                    }
                                                    return chat
                                                })
                                                setGroupChats(chatGroupMapping)
                                            }}
                                        >
                                            <div className='d-flex '>
                                                <div style={{ backgroundColor: "#706D6D", width: "40px", height: "40px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: "15px" }}>
                                                    {filteredGroupName != '' ? getInitials(filteredGroupName) : ''}
                                                </div>
                                                {group?.is_group_chat ? <div className='d-flex flex-column justify-content-end '>
                                                    <div style={{
                                                        marginLeft: "-17px", backgroundColor: "white",
                                                        borderRadius: "50%", display: "flex",
                                                        height: "20px", width: "20px",
                                                        border: "1px solid #706D6D",
                                                        justifyContent: "center",
                                                        alignItems: "center"
                                                    }}>
                                                        <HiUserGroup />
                                                    </div>
                                                </div> : ''}
                                            </div>
                                            <div className='d-flex flex-column justify-content-center ms-2'>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="chat-name">{filteredGroupName}</div>
                                                </div>
                                                <div className="chat-message">{group?.description}</div>

                                            </div>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "auto" }}>
                                                {group?.new_message_sent && <div className="new-message-circle">{group?.unread_count}</div>}
                                            </div>
                                        </li>
                                    )
                                }
                                )}
                            </ul>}
                            <hr />
                            <div style={{ width: "100%", padding: "0px", margin: "0px !important" }} className='mt-3 d-flex justify-content-between C-pointer px-2' onClick={() => setMinimizeAllUsers(!minimizeAllUsers)}>
                                <div>All Users</div>
                                <img
                                    src={'./images/icons/RightArrow.svg'}
                                    alt={minimizeAllUsers ? "Down arrow" : "Right arrow"}
                                    className={`arrow ${minimizeAllUsers ? 'arrow-down' : 'arrow-right'}`}
                                />
                            </div>
                            {minimizeAllUsers && <ul className='mt-3 chat-list-item'>
                                {allUsersWithChats.map((user, index) => {
                                    return (
                                        <li
                                            key={index}
                                            className={`${selectedChat === index ? "active" : ""} d-flex`}
                                            onClick={() => {
                                                minimizedChat && setMobileChatWindow(true)
                                                setSelectedChatGroup(null)
                                                setSelectedChat(index)
                                                // setSelectedChatUser(user)
                                                const findChat = chatsArray.find(chat => chat.username === user.username)
                                                setSelectedChatUser(findChat)

                                            }}
                                        >
                                            <div style={{ backgroundColor: "#706D6D", width: "40px", height: "40px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: "15px" }}>
                                                {getInitials(user?.name)}
                                            </div>
                                            <div className='d-flex flex-column justify-content-center ms-2'>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="chat-name">{user?.name}</div>
                                                </div>
                                                {user?.message?.message ? <b>{user?.message?.message}</b> : <div className="chat-message">{user?.username}</div>}
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>}
                        </div> :
                            <>
                                {!isGroupChatNextClicked ? <div className='d-flex flex-column justify-content-between' style={{ height: '60vh' }}>
                                    <div>
                                        <div className='d-flex align-items-center gap-1 px-4 flex-wrap' style={{ maxHeight: '10vh', overflowY: 'auto' }}>
                                            {groupChatMembersArray?.map((member, index) => {
                                                return (
                                                    <div key={index} className='d-flex align-items-center gap-2 group-chat-member-adding'>
                                                        <div>{member?.name}</div>
                                                        <button className='' onClick={() => {
                                                            setMemberToDelete(member);
                                                            setShowDeleteMemberConfirm(true);
                                                        }}>X</button>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div style={{ width: "100%", padding: "0px", margin: "0px !important" }}
                                            className='mt-3 d-flex justify-content-between C-pointer px-2'
                                        // onClick={() => setMinimizeAllUsers(!minimizeAllUsers)}
                                        >
                                            <div>Add Members</div>
                                        </div>
                                        <div className="chat-list-scroll" style={{ height: '40vh' }}>
                                            <ul className='mt-3 chat-list-item'>
                                                {allUsersWithChatsForGroup.map((user, index) => {
                                                    return (
                                                        <li
                                                            key={index}
                                                            className={`${selectedChat === index ? "active" : ""} d-flex`}
                                                            onClick={() => {
                                                                const newGroupMembersArray = [...groupChatMembersArray, user]
                                                                setGroupChatMembersArray(newGroupMembersArray)
                                                                const newMembers = allUsersWithChatsForGroup.filter(member => member.user_id !== user.user_id)
                                                                setAllUsersWithChatsForGroup(newMembers)
                                                            }}
                                                        >
                                                            <div style={{ backgroundColor: "#706D6D", width: "40px", height: "40px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: "15px" }}>
                                                                {getInitials(user?.name)}
                                                            </div>
                                                            <div className='d-flex flex-column justify-content-center ms-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <div className="chat-name">{user?.name}</div>
                                                                </div>
                                                                {user?.message?.message ? <b>{user?.message?.message}</b> : <div className="chat-message">{user?.username}</div>}
                                                            </div>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='chat-group-next-div C-pointer'
                                        onClick={() => {
                                            setIsGroupChatNextClicked(true)
                                        }}
                                    >
                                        <FaRegArrowAltCircleRight style={{
                                            height: '30px',
                                            width: '30px',
                                            color: 'gray'
                                        }} />
                                    </div>
                                </div> :
                                    <div className='px-4'>
                                        <div className='C-pointer' onClick={() => {
                                            setIsGroupChatNextClicked(false)
                                        }}>
                                            <FaRegArrowAltCircleLeft style={{
                                                height: '25px',
                                                width: '25px',
                                                color: 'gray',
                                                marginBottom: '10px'
                                            }} />
                                        </div>
                                        <div>
                                            <label>Group Name</label>
                                            <input type="text" placeholder="Group Name" className='form-control mb-3' value={groupChatName} onChange={(e) => {
                                                setGroupChatName(e.target.value)
                                            }
                                            } />
                                            <label>Group Description</label>
                                            <input type="text" placeholder="Group Description" className='form-control mb-3' value={groupChatDescription} onChange={(e) => {
                                                setGroupChatDescription(e.target.value)
                                            }
                                            } />
                                            <div className='d-flex justify-content-center'>
                                                <button className='group-chat-create-button' onClick={() => {
                                                    const members = groupChatMembersArray.map(member => member.user_id)
                                                    createAGroupChatforGroup()
                                                }}>Create Group</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>}
                    </div>}
                    {!minimizedChat && chatWindowContent()}
                    {viewImage &&
                        <ImageViewer
                            fileName={viewImage.file_name}
                            base64={viewImage.file}
                            setViewImage={setViewImage}
                        />
                    }
                    {/* {showCamera && <Camera
                        sendMessageMethod={sendMessageMethod}
                        capturedImage={capturedImage}
                        capturePhoto={capturePhoto}
                        changeCameraView={changeCameraView}
                        videoConstraints={videoConstraints}
                        webcamRef={webcamRef}
                        textInput={textInput}
                        setTextInput={setTextInput}
                        closeCamera={() => {
                            setShowCamera(false)
                            setCapturedImage(null)
                        }}
                    />} */}
                </div>
            </div >
            <Modal
                backdrop="static"
                keyboard={false}  // Prevents modal from closing on "Esc" key press
                show={addGroupMemberModalClicked}
                centered
                className="popper-modal"
                style={{ zIndex: 99999 }}
            >
                <Modal.Header className="d-flex justify-content-between">
                    <h5>Add Group Members</h5>
                    <IoClose className='C-pointer' onClick={() => {
                        setAddGroupMemberModalClicked(false)
                        setGroupChatMembersArray([])
                        setShowGroupMembers(false)
                    }} style={{ color: "black", height: "30", width: "30" }} />
                </Modal.Header>
                <Modal.Body className="">
                    <div>
                        <div style={{ width: "100%", padding: "0px", margin: "0px !important" }}
                            className='mt-3 d-flex justify-content-between C-pointer px-2'
                        // onClick={() => setMinimizeAllUsers(!minimizeAllUsers)}
                        >
                            <div>Group Members</div>
                        </div>
                        <div className='d-flex align-items-center gap-1 px-4 flex-wrap' style={{ maxHeight: '10vh', overflowY: 'auto' }}>
                            {groupChatMembersArray?.map((member, index) => {
                                return (
                                    <div key={index} className='d-flex align-items-center gap-2 group-chat-member-adding'>
                                        <div>{member?.name}</div>
                                        <button className='' onClick={() => {
                                            setMemberToDelete(member);
                                            setShowDeleteMemberConfirm(true);
                                        }}>X</button>
                                    </div>
                                )
                            })}
                        </div>
                        <div style={{ width: "100%", padding: "0px", margin: "0px !important" }}
                            className='mt-3 d-flex justify-content-between C-pointer px-2'
                        // onClick={() => setMinimizeAllUsers(!minimizeAllUsers)}
                        >
                            <div>Add Members</div>
                        </div>
                        <div className="chat-list-scroll" style={{ height: '40vh' }}>
                            <ul className='mt-3 chat-list-item'>
                                {allUsersWithChatsForGroup.map((user, index) => {
                                    return (
                                        <li
                                            key={index}
                                            className={`${selectedChat === index ? "active" : ""} d-flex`}
                                            onClick={() => {
                                                // const newGroupMembersArray = [...groupChatMembersArray, user]
                                                // setGroupChatMembersArray(newGroupMembersArray)
                                                // const newMembers = allUsersWithChatsForGroup.filter(member => member.user_id !== user.user_id)
                                                // setAllUsersWithChatsForGroup(newMembers)
                                                addNewMembersToGroup(user)
                                            }}
                                        >
                                            <div style={{ backgroundColor: "#706D6D", width: "40px", height: "40px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: "15px" }}>
                                                {getInitials(user?.name)}
                                            </div>
                                            <div className='d-flex flex-column justify-content-center ms-2'>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="chat-name">{user?.name}</div>
                                                </div>
                                                {user?.message?.message ? <b>{user?.message?.message}</b> : <div className="chat-message">{user?.username}</div>}
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>

                </Modal.Body>
                {/* <Modal.Footer className="footer d-flex justify-content-center">
                    <button className="btn"
                        style={{
                            backgroundColor: 'gray',
                            color: 'white',

                        }}
                        onClick={() => {
                            setAddGroupMemberModalClicked(false)
                        }}>Add Members</button>
                </Modal.Footer> */}
            </Modal>

            <AlertPopup
                alertShow={errorMsg !== null}
                alertType="error"
                alertMsg={"Error"}
                alertValue={errorMsg}
                alertButtons={[{ name: "Close", action: () => { setErrorMsg(null) } }]}
            />
            <AlertPopup
                alertShow={showDeleteMemberConfirm}
                alertType="question"
                alertMsg="Confirmation"
                alertValue={`Are you sure you want to remove ${memberToDelete?.name} from the group?`}
                alertButtons={[
                    {
                        name: 'Cancel',
                        action: () => setShowDeleteMemberConfirm(false),
                        variant: 'secondary'
                    },
                    {
                        name: 'Remove',
                        action: () => {
                            setShowDeleteMemberConfirm(false);
                            deleteMemberFromGroup(memberToDelete);
                        },
                        variant: 'primary'
                    }
                ]}
            />
            <AlertPopup
                alertShow={showLeaveGroupConfirm}
                alertType="question"
                alertMsg="Confirmation"
                alertValue="Are you sure you want to leave this group?"
                alertButtons={[
                    {
                        name: 'Cancel',
                        action: () => setShowLeaveGroupConfirm(false),
                        variant: 'secondary'
                    },
                    {
                        name: 'Leave',
                        action: () => {
                            setShowLeaveGroupConfirm(false);
                            leaveAGroup(memberToLeave);
                        },
                        variant: 'primary'
                    }
                ]}
            />
            <Footer />
        </>
    )
}